import { useState, useEffect } from 'react';
import api from '../services/api';

export const useProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProjects = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get('/projects');
      setProjects(res.data.projects);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch projects');
    } finally {
      setLoading(false);
    }
  };

  const createProject = async (projectData) => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.post('/projects', projectData);
      setProjects([res.data.project, ...projects]);
      return res.data.project;
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create project');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const updateProject = async (id, updates) => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.put(`/projects/${id}`, updates);
      setProjects(projects.map(p => p.id === id ? res.data.project : p));
      return res.data.project;
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update project');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const deleteProject = async (id) => {
    setLoading(true);
    setError(null);
    try {
      await api.delete(`/projects/${id}`);
      setProjects(projects.filter(p => p.id !== id));
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to delete project');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Skip API calls during react-snap prerendering (no backend)
    if (typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap') return;
    fetchProjects();
  }, []);

  return {
    projects,
    loading,
    error,
    fetchProjects,
    createProject,
    updateProject,
    deleteProject,
  };
};

